module.exports = __webpack_public_path__ + "img/add-schedule.c99697ce.svg";